module.exports = __webpack_public_path__ + "img/undraw_taking_notes.24a7bd34.svg";